webpackJsonp([189066279150898],{

/***/ 292:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.defaultMaskChar = exports.defaultCharsRules = void 0;
	var defaultCharsRules = {
	  '9': '[0-9]',
	  'a': '[A-Za-z]',
	  '*': '[A-Za-z0-9]'
	};
	exports.defaultCharsRules = defaultCharsRules;
	var defaultMaskChar = '_';
	exports.defaultMaskChar = defaultMaskChar;

/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _parseMask = _interopRequireDefault(__webpack_require__(296));
	
	var _environment = __webpack_require__(295);
	
	var _string = __webpack_require__(297);
	
	var _defer = _interopRequireDefault(__webpack_require__(294));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _instanceof(left, right) { if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) { return right[Symbol.hasInstance](left); } else { return left instanceof right; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var InputElement =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(InputElement, _React$Component);
	
	  function InputElement(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	
	    _initialiseProps.call(_assertThisInitialized(_this));
	
	    var mask = props.mask,
	        maskChar = props.maskChar,
	        formatChars = props.formatChars,
	        defaultValue = props.defaultValue,
	        value = props.value,
	        alwaysShowMask = props.alwaysShowMask;
	    _this.hasValue = value != null;
	    _this.maskOptions = (0, _parseMask.default)(mask, maskChar, formatChars);
	
	    if (defaultValue == null) {
	      defaultValue = '';
	    }
	
	    if (value == null) {
	      value = defaultValue;
	    }
	
	    value = _this.getStringValue(value);
	
	    if (_this.maskOptions.mask && (alwaysShowMask || value)) {
	      value = (0, _string.formatValue)(_this.maskOptions, value);
	    }
	
	    _this.value = value;
	    return _this;
	  }
	
	  var _proto = InputElement.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.isAndroidBrowser = (0, _environment.isAndroidBrowser)();
	    this.isWindowsPhoneBrowser = (0, _environment.isWindowsPhoneBrowser)();
	    this.isAndroidFirefox = (0, _environment.isAndroidFirefox)();
	
	    if (this.maskOptions.mask && this.getInputValue() !== this.value) {
	      this.setInputValue(this.value);
	    }
	  };
	
	  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var oldMaskOptions = this.maskOptions;
	    this.hasValue = nextProps.value != null;
	    this.maskOptions = (0, _parseMask.default)(nextProps.mask, nextProps.maskChar, nextProps.formatChars);
	
	    if (!this.maskOptions.mask) {
	      this.backspaceOrDeleteRemoval = null;
	      this.lastCursorPos = null;
	      return;
	    }
	
	    var isMaskChanged = this.maskOptions.mask && this.maskOptions.mask !== oldMaskOptions.mask;
	    var showEmpty = nextProps.alwaysShowMask || this.isFocused();
	    var newValue = this.hasValue ? this.getStringValue(nextProps.value) : this.value;
	
	    if (!oldMaskOptions.mask && !this.hasValue) {
	      newValue = this.getInputValue();
	    }
	
	    if (isMaskChanged || this.maskOptions.mask && (newValue || showEmpty)) {
	      newValue = (0, _string.formatValue)(this.maskOptions, newValue);
	
	      if (isMaskChanged) {
	        var pos = this.lastCursorPos;
	        var filledLen = (0, _string.getFilledLength)(this.maskOptions, newValue);
	
	        if (pos === null || filledLen < pos) {
	          if ((0, _string.isFilled)(this.maskOptions, newValue)) {
	            pos = filledLen;
	          } else {
	            pos = this.getRightEditablePos(filledLen);
	          }
	
	          this.setCursorPos(pos);
	        }
	      }
	    }
	
	    if (this.maskOptions.mask && (0, _string.isEmpty)(this.maskOptions, newValue) && !showEmpty && (!this.hasValue || !nextProps.value)) {
	      newValue = '';
	    }
	
	    this.value = newValue;
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate() {
	    if (this.maskOptions.mask && this.getInputValue() !== this.value) {
	      this.setInputValue(this.value);
	    }
	  };
	
	  _proto.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        mask = _props.mask,
	        alwaysShowMask = _props.alwaysShowMask,
	        maskChar = _props.maskChar,
	        formatChars = _props.formatChars,
	        inputRef = _props.inputRef,
	        props = _objectWithoutProperties(_props, ["mask", "alwaysShowMask", "maskChar", "formatChars", "inputRef"]);
	
	    if (this.maskOptions.mask) {
	      if (!props.disabled && !props.readOnly) {
	        var handlersKeys = ['onChange', 'onKeyDown', 'onPaste', 'onMouseDown'];
	        handlersKeys.forEach(function (key) {
	          props[key] = _this2[key];
	        });
	      }
	
	      if (props.value != null) {
	        props.value = this.value;
	      }
	    }
	
	    return _react.default.createElement("input", _extends({
	      ref: this.handleRef
	    }, props, {
	      onFocus: this.onFocus,
	      onBlur: this.onBlur
	    }));
	  };
	
	  return InputElement;
	}(_react.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  Object.defineProperty(this, "lastCursorPos", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: null
	  });
	  Object.defineProperty(this, "focused", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: false
	  });
	  Object.defineProperty(this, "isDOMElement", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: function value(element) {
	      return (typeof HTMLElement === "undefined" ? "undefined" : _typeof(HTMLElement)) === 'object' ? _instanceof(element, HTMLElement) // DOM2
	      : element.nodeType === 1 && typeof element.nodeName === 'string';
	    }
	  });
	  Object.defineProperty(this, "getInputDOMNode", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: function value() {
	      var input = _this3.input;
	
	      if (!input) {
	        return null;
	      }
	
	      if (_this3.isDOMElement(input)) {
	        return input;
	      } // React 0.13
	
	
	      return _react.default.findDOMNode(input);
	    }
	  });
	  Object.defineProperty(this, "getInputValue", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: function value() {
	      var input = _this3.getInputDOMNode();
	
	      if (!input) {
	        return null;
	      }
	
	      return input.value;
	    }
	  });
	  Object.defineProperty(this, "setInputValue", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: function value(_value) {
	      var input = _this3.getInputDOMNode();
	
	      if (!input) {
	        return;
	      }
	
	      _this3.value = _value;
	      input.value = _value;
	    }
	  });
	  Object.defineProperty(this, "getLeftEditablePos", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: function value(pos) {
	      for (var i = pos; i >= 0; --i) {
	        if (!(0, _string.isPermanentChar)(_this3.maskOptions, i)) {
	          return i;
	        }
	      }
	
	      return null;
	    }
	  });
	  Object.defineProperty(this, "getRightEditablePos", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: function value(pos) {
	      var mask = _this3.maskOptions.mask;
	
	      for (var i = pos; i < mask.length; ++i) {
	        if (!(0, _string.isPermanentChar)(_this3.maskOptions, i)) {
	          return i;
	        }
	      }
	
	      return null;
	    }
	  });
	  Object.defineProperty(this, "setCursorToEnd", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: function value() {
	      var filledLen = (0, _string.getFilledLength)(_this3.maskOptions, _this3.value);
	
	      var pos = _this3.getRightEditablePos(filledLen);
	
	      if (pos !== null) {
	        _this3.setCursorPos(pos);
	      }
	    }
	  });
	  Object.defineProperty(this, "setSelection", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: function value(start, len) {
	      if (len === void 0) {
	        len = 0;
	      }
	
	      var input = _this3.getInputDOMNode();
	
	      if (!input) {
	        return;
	      }
	
	      var end = start + len;
	
	      if ('selectionStart' in input && 'selectionEnd' in input) {
	        input.selectionStart = start;
	        input.selectionEnd = end;
	      } else {
	        var range = input.createTextRange();
	        range.collapse(true);
	        range.moveStart('character', start);
	        range.moveEnd('character', end - start);
	        range.select();
	      }
	    }
	  });
	  Object.defineProperty(this, "getSelection", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: function value() {
	      var input = _this3.getInputDOMNode();
	
	      var start = 0;
	      var end = 0;
	
	      if ('selectionStart' in input && 'selectionEnd' in input) {
	        start = input.selectionStart;
	        end = input.selectionEnd;
	      } else {
	        var range = document.selection.createRange();
	
	        if (range.parentElement() === input) {
	          start = -range.moveStart('character', -input.value.length);
	          end = -range.moveEnd('character', -input.value.length);
	        }
	      }
	
	      return {
	        start: start,
	        end: end,
	        length: end - start
	      };
	    }
	  });
	  Object.defineProperty(this, "getCursorPos", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: function value() {
	      return _this3.getSelection().start;
	    }
	  });
	  Object.defineProperty(this, "setCursorPos", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: function value(pos) {
	      _this3.setSelection(pos, 0);
	
	      (0, _defer.default)(function () {
	        _this3.setSelection(pos, 0);
	      });
	      _this3.lastCursorPos = pos;
	    }
	  });
	  Object.defineProperty(this, "isFocused", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: function value() {
	      return _this3.focused;
	    }
	  });
	  Object.defineProperty(this, "getStringValue", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: function value(_value2) {
	      return !_value2 && _value2 !== 0 ? '' : _value2 + '';
	    }
	  });
	  Object.defineProperty(this, "onKeyDown", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: function value(event) {
	      _this3.backspaceOrDeleteRemoval = null;
	
	      if (typeof _this3.props.onKeyDown === 'function') {
	        _this3.props.onKeyDown(event);
	      }
	
	      var key = event.key,
	          ctrlKey = event.ctrlKey,
	          metaKey = event.metaKey,
	          defaultPrevented = event.defaultPrevented;
	
	      if (ctrlKey || metaKey || defaultPrevented) {
	        return;
	      }
	
	      if (key === 'Backspace' || key === 'Delete') {
	        var selection = _this3.getSelection();
	
	        var canRemove = key === 'Backspace' && selection.end > 0 || key === 'Delete' && _this3.value.length > selection.start;
	
	        if (!canRemove) {
	          return;
	        }
	
	        _this3.backspaceOrDeleteRemoval = {
	          key: key,
	          selection: _this3.getSelection()
	        };
	      }
	    }
	  });
	  Object.defineProperty(this, "onChange", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: function value(event) {
	      var beforePasteState = _this3.beforePasteState;
	      var _this3$maskOptions = _this3.maskOptions,
	          mask = _this3$maskOptions.mask,
	          maskChar = _this3$maskOptions.maskChar,
	          lastEditablePos = _this3$maskOptions.lastEditablePos,
	          prefix = _this3$maskOptions.prefix;
	
	      var value = _this3.getInputValue();
	
	      if (beforePasteState) {
	        _this3.beforePasteState = null;
	
	        _this3.pasteText(beforePasteState.value, value, beforePasteState.selection, event);
	
	        return;
	      }
	
	      var oldValue = _this3.value;
	
	      var input = _this3.getInputDOMNode(); // autofill replaces whole value, ignore old one
	      // https://github.com/sanniassin/react-input-mask/issues/113
	      //
	      // input.matches throws exception if selector isn't supported
	
	
	      try {
	        if (typeof input.matches === 'function' && input.matches(':-webkit-autofill')) {
	          oldValue = '';
	        }
	      } catch (e) {}
	
	      var selection = _this3.getSelection();
	
	      var cursorPos = selection.end;
	      var maskLen = mask.length;
	      var valueLen = value.length;
	      var oldValueLen = oldValue.length;
	      var clearedValue;
	      var enteredString;
	
	      if (_this3.backspaceOrDeleteRemoval) {
	        var deleteFromRight = _this3.backspaceOrDeleteRemoval.key === 'Delete';
	        value = _this3.value;
	        selection = _this3.backspaceOrDeleteRemoval.selection;
	        cursorPos = selection.start;
	        _this3.backspaceOrDeleteRemoval = null;
	
	        if (selection.length) {
	          value = (0, _string.clearRange)(_this3.maskOptions, value, selection.start, selection.length);
	        } else if (selection.start < prefix.length || !deleteFromRight && selection.start === prefix.length) {
	          cursorPos = prefix.length;
	        } else {
	          var editablePos = deleteFromRight ? _this3.getRightEditablePos(cursorPos) : _this3.getLeftEditablePos(cursorPos - 1);
	
	          if (editablePos !== null) {
	            if (!maskChar) {
	              value = value.substr(0, (0, _string.getFilledLength)(_this3.maskOptions, value));
	            }
	
	            value = (0, _string.clearRange)(_this3.maskOptions, value, editablePos, 1);
	            cursorPos = editablePos;
	          }
	        }
	      } else if (valueLen > oldValueLen) {
	        var enteredStringLen = valueLen - oldValueLen;
	        var startPos = selection.end - enteredStringLen;
	        enteredString = value.substr(startPos, enteredStringLen);
	
	        if (startPos < lastEditablePos && (enteredStringLen !== 1 || enteredString !== mask[startPos])) {
	          cursorPos = _this3.getRightEditablePos(startPos);
	        } else {
	          cursorPos = startPos;
	        }
	
	        value = value.substr(0, startPos) + value.substr(startPos + enteredStringLen);
	        clearedValue = (0, _string.clearRange)(_this3.maskOptions, value, startPos, maskLen - startPos);
	        clearedValue = (0, _string.insertString)(_this3.maskOptions, clearedValue, enteredString, cursorPos);
	        value = (0, _string.insertString)(_this3.maskOptions, oldValue, enteredString, cursorPos);
	
	        if (enteredStringLen !== 1 || cursorPos >= prefix.length && cursorPos < lastEditablePos) {
	          cursorPos = Math.max((0, _string.getFilledLength)(_this3.maskOptions, clearedValue), cursorPos);
	
	          if (cursorPos < lastEditablePos) {
	            cursorPos = _this3.getRightEditablePos(cursorPos);
	          }
	        } else if (cursorPos < lastEditablePos) {
	          cursorPos++;
	        }
	      } else if (valueLen < oldValueLen) {
	        var removedLen = maskLen - valueLen;
	        enteredString = value.substr(0, selection.end);
	        var clearOnly = enteredString === oldValue.substr(0, selection.end);
	        clearedValue = (0, _string.clearRange)(_this3.maskOptions, oldValue, selection.end, removedLen);
	
	        if (maskChar) {
	          value = (0, _string.insertString)(_this3.maskOptions, clearedValue, enteredString, 0);
	        }
	
	        clearedValue = (0, _string.clearRange)(_this3.maskOptions, clearedValue, selection.end, maskLen - selection.end);
	        clearedValue = (0, _string.insertString)(_this3.maskOptions, clearedValue, enteredString, 0);
	
	        if (!clearOnly) {
	          cursorPos = Math.max((0, _string.getFilledLength)(_this3.maskOptions, clearedValue), cursorPos);
	
	          if (cursorPos < lastEditablePos) {
	            cursorPos = _this3.getRightEditablePos(cursorPos);
	          }
	        } else if (cursorPos < prefix.length) {
	          cursorPos = prefix.length;
	        }
	      }
	
	      value = (0, _string.formatValue)(_this3.maskOptions, value);
	
	      _this3.setInputValue(value);
	
	      if (typeof _this3.props.onChange === 'function') {
	        _this3.props.onChange(event);
	      }
	
	      if (_this3.isWindowsPhoneBrowser) {
	        (0, _defer.default)(function () {
	          _this3.setSelection(cursorPos, 0);
	        });
	      } else {
	        _this3.setCursorPos(cursorPos);
	      }
	    }
	  });
	  Object.defineProperty(this, "onFocus", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: function value(event) {
	      _this3.focused = true;
	
	      if (_this3.maskOptions.mask) {
	        if (!_this3.value) {
	          var prefix = _this3.maskOptions.prefix;
	          var value = (0, _string.formatValue)(_this3.maskOptions, prefix);
	          var inputValue = (0, _string.formatValue)(_this3.maskOptions, value); // do not use this.getInputValue and this.setInputValue as this.input
	          // can be undefined at this moment if autoFocus attribute is set
	
	          var isInputValueChanged = inputValue !== event.target.value;
	
	          if (isInputValueChanged) {
	            event.target.value = inputValue;
	          }
	
	          _this3.value = inputValue;
	
	          if (isInputValueChanged && typeof _this3.props.onChange === 'function') {
	            _this3.props.onChange(event);
	          }
	
	          _this3.setCursorToEnd();
	        } else if ((0, _string.getFilledLength)(_this3.maskOptions, _this3.value) < _this3.maskOptions.mask.length) {
	          _this3.setCursorToEnd();
	        }
	      }
	
	      if (typeof _this3.props.onFocus === 'function') {
	        _this3.props.onFocus(event);
	      }
	    }
	  });
	  Object.defineProperty(this, "onBlur", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: function value(event) {
	      _this3.focused = false;
	
	      if (_this3.maskOptions.mask && !_this3.props.alwaysShowMask && (0, _string.isEmpty)(_this3.maskOptions, _this3.value)) {
	        var inputValue = '';
	
	        var isInputValueChanged = inputValue !== _this3.getInputValue();
	
	        if (isInputValueChanged) {
	          _this3.setInputValue(inputValue);
	        }
	
	        if (isInputValueChanged && typeof _this3.props.onChange === 'function') {
	          _this3.props.onChange(event);
	        }
	      }
	
	      if (typeof _this3.props.onBlur === 'function') {
	        _this3.props.onBlur(event);
	      }
	    }
	  });
	  Object.defineProperty(this, "onMouseDown", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: function value(event) {
	      // tiny unintentional mouse movements can break cursor
	      // position on focus, so we have to restore it in that case
	      //
	      // https://github.com/sanniassin/react-input-mask/issues/108
	      if (!_this3.focused && document.addEventListener) {
	        _this3.mouseDownX = event.clientX;
	        _this3.mouseDownY = event.clientY;
	        _this3.mouseDownTime = new Date().getTime();
	
	        var mouseUpHandler = function mouseUpHandler(mouseUpEvent) {
	          document.removeEventListener('mouseup', mouseUpHandler);
	
	          if (!_this3.focused) {
	            return;
	          }
	
	          var deltaX = Math.abs(mouseUpEvent.clientX - _this3.mouseDownX);
	          var deltaY = Math.abs(mouseUpEvent.clientY - _this3.mouseDownY);
	          var axisDelta = Math.max(deltaX, deltaY);
	
	          var timeDelta = new Date().getTime() - _this3.mouseDownTime;
	
	          if (axisDelta <= 10 && timeDelta <= 200 || axisDelta <= 5 && timeDelta <= 300) {
	            _this3.setCursorToEnd();
	          }
	        };
	
	        document.addEventListener('mouseup', mouseUpHandler);
	      }
	
	      if (typeof _this3.props.onMouseDown === 'function') {
	        _this3.props.onMouseDown(event);
	      }
	    }
	  });
	  Object.defineProperty(this, "onPaste", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: function value(event) {
	      if (typeof _this3.props.onPaste === 'function') {
	        _this3.props.onPaste(event);
	      } // we need raw pasted text, but event.clipboardData
	      // may not work in Android browser, so we clean input
	      // to get raw text in onChange handler
	
	
	      if (!event.defaultPrevented) {
	        _this3.beforePasteState = {
	          value: _this3.getInputValue(),
	          selection: _this3.getSelection()
	        };
	
	        _this3.setInputValue('');
	      }
	    }
	  });
	  Object.defineProperty(this, "pasteText", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: function value(_value3, text, selection, event) {
	      var cursorPos = selection.start;
	
	      if (selection.length) {
	        _value3 = (0, _string.clearRange)(_this3.maskOptions, _value3, cursorPos, selection.length);
	      }
	
	      var textLen = (0, _string.getInsertStringLength)(_this3.maskOptions, _value3, text, cursorPos);
	      _value3 = (0, _string.insertString)(_this3.maskOptions, _value3, text, cursorPos);
	      cursorPos += textLen;
	      cursorPos = _this3.getRightEditablePos(cursorPos) || cursorPos;
	
	      _this3.setInputValue(_value3);
	
	      if (event && typeof _this3.props.onChange === 'function') {
	        _this3.props.onChange(event);
	      }
	
	      _this3.setCursorPos(cursorPos);
	    }
	  });
	  Object.defineProperty(this, "handleRef", {
	    configurable: true,
	    enumerable: true,
	    writable: true,
	    value: function value(ref) {
	      _this3.input = ref;
	
	      if (typeof _this3.props.inputRef === 'function') {
	        _this3.props.inputRef(ref);
	      }
	    }
	  });
	};
	
	var _default = InputElement;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),

/***/ 294:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = _default;
	
	function _default(fn) {
	  var defer = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function () {
	    return setTimeout(fn, 0);
	  };
	
	  return defer(fn);
	}
	
	module.exports = exports["default"];

/***/ }),

/***/ 295:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.isAndroidBrowser = isAndroidBrowser;
	exports.isWindowsPhoneBrowser = isWindowsPhoneBrowser;
	exports.isAndroidFirefox = isAndroidFirefox;
	exports.isIOS = isIOS;
	
	function isAndroidBrowser() {
	  var windows = new RegExp('windows', 'i');
	  var firefox = new RegExp('firefox', 'i');
	  var android = new RegExp('android', 'i');
	  var ua = navigator.userAgent;
	  return !windows.test(ua) && !firefox.test(ua) && android.test(ua);
	}
	
	function isWindowsPhoneBrowser() {
	  var windows = new RegExp('windows', 'i');
	  var phone = new RegExp('phone', 'i');
	  var ua = navigator.userAgent;
	  return windows.test(ua) && phone.test(ua);
	}
	
	function isAndroidFirefox() {
	  var windows = new RegExp('windows', 'i');
	  var firefox = new RegExp('firefox', 'i');
	  var android = new RegExp('android', 'i');
	  var ua = navigator.userAgent;
	  return !windows.test(ua) && firefox.test(ua) && android.test(ua);
	}
	
	function isIOS() {
	  var windows = new RegExp('windows', 'i');
	  var ios = new RegExp('(ipod|iphone|ipad)', 'i');
	  var ua = navigator.userAgent;
	  return !windows.test(ua) && ios.test(ua);
	}

/***/ }),

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = _default;
	
	var _constants = __webpack_require__(292);
	
	function _default(mask, maskChar, charsRules) {
	  if (maskChar === undefined) {
	    maskChar = _constants.defaultMaskChar;
	  }
	
	  if (charsRules == null) {
	    charsRules = _constants.defaultCharsRules;
	  }
	
	  if (!mask || typeof mask !== 'string') {
	    return {
	      maskChar: maskChar,
	      charsRules: charsRules,
	      mask: null,
	      prefix: null,
	      lastEditablePos: null,
	      permanents: []
	    };
	  }
	
	  var str = '';
	  var prefix = '';
	  var permanents = [];
	  var isPermanent = false;
	  var lastEditablePos = null;
	  mask.split('').forEach(function (character) {
	    if (!isPermanent && character === '\\') {
	      isPermanent = true;
	    } else {
	      if (isPermanent || !charsRules[character]) {
	        permanents.push(str.length);
	
	        if (str.length === permanents.length - 1) {
	          prefix += character;
	        }
	      } else {
	        lastEditablePos = str.length + 1;
	      }
	
	      str += character;
	      isPermanent = false;
	    }
	  });
	  return {
	    maskChar: maskChar,
	    charsRules: charsRules,
	    prefix: prefix,
	    mask: str,
	    lastEditablePos: lastEditablePos,
	    permanents: permanents
	  };
	}
	
	module.exports = exports["default"];

/***/ }),

/***/ 297:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.isPermanentChar = isPermanentChar;
	exports.isAllowedChar = isAllowedChar;
	exports.isEmpty = isEmpty;
	exports.getFilledLength = getFilledLength;
	exports.isFilled = isFilled;
	exports.formatValue = formatValue;
	exports.clearRange = clearRange;
	exports.insertString = insertString;
	exports.getInsertStringLength = getInsertStringLength;
	
	function isPermanentChar(maskOptions, pos) {
	  return maskOptions.permanents.indexOf(pos) !== -1;
	}
	
	function isAllowedChar(maskOptions, pos, character) {
	  var mask = maskOptions.mask,
	      charsRules = maskOptions.charsRules;
	
	  if (!character) {
	    return false;
	  }
	
	  if (isPermanentChar(maskOptions, pos)) {
	    return mask[pos] === character;
	  }
	
	  var ruleChar = mask[pos];
	  var charRule = charsRules[ruleChar];
	  return new RegExp(charRule).test(character);
	}
	
	function isEmpty(maskOptions, value) {
	  return value.split('').every(function (character, i) {
	    return isPermanentChar(maskOptions, i) || !isAllowedChar(maskOptions, i, character);
	  });
	}
	
	function getFilledLength(maskOptions, value) {
	  var maskChar = maskOptions.maskChar,
	      prefix = maskOptions.prefix;
	
	  if (!maskChar) {
	    while (value.length > prefix.length && isPermanentChar(maskOptions, value.length - 1)) {
	      value = value.slice(0, value.length - 1);
	    }
	
	    return value.length;
	  }
	
	  var filledLength = prefix.length;
	
	  for (var i = value.length; i >= prefix.length; i--) {
	    var character = value[i];
	    var isEnteredCharacter = !isPermanentChar(maskOptions, i) && isAllowedChar(maskOptions, i, character);
	
	    if (isEnteredCharacter) {
	      filledLength = i + 1;
	      break;
	    }
	  }
	
	  return filledLength;
	}
	
	function isFilled(maskOptions, value) {
	  return getFilledLength(maskOptions, value) === maskOptions.mask.length;
	}
	
	function formatValue(maskOptions, value) {
	  var maskChar = maskOptions.maskChar,
	      mask = maskOptions.mask,
	      prefix = maskOptions.prefix;
	
	  if (!maskChar) {
	    value = insertString(maskOptions, '', value, 0);
	
	    if (value.length < prefix.length) {
	      value = prefix;
	    }
	
	    while (value.length < mask.length && isPermanentChar(maskOptions, value.length)) {
	      value += mask[value.length];
	    }
	
	    return value;
	  }
	
	  if (value) {
	    var emptyValue = formatValue(maskOptions, '');
	    return insertString(maskOptions, emptyValue, value, 0);
	  }
	
	  for (var i = 0; i < mask.length; i++) {
	    if (isPermanentChar(maskOptions, i)) {
	      value += mask[i];
	    } else {
	      value += maskChar;
	    }
	  }
	
	  return value;
	}
	
	function clearRange(maskOptions, value, start, len) {
	  var end = start + len;
	  var maskChar = maskOptions.maskChar,
	      mask = maskOptions.mask,
	      prefix = maskOptions.prefix;
	  var arrayValue = value.split('');
	
	  if (!maskChar) {
	    // remove any permanent chars after clear range, they will be added back by foramtValue
	    for (var i = end; i < arrayValue.length; i++) {
	      if (isPermanentChar(maskOptions, i)) {
	        arrayValue[i] = '';
	      }
	    }
	
	    start = Math.max(prefix.length, start);
	    arrayValue.splice(start, end - start);
	    value = arrayValue.join('');
	    return formatValue(maskOptions, value);
	  }
	
	  return arrayValue.map(function (character, i) {
	    if (i < start || i >= end) {
	      return character;
	    }
	
	    if (isPermanentChar(maskOptions, i)) {
	      return mask[i];
	    }
	
	    return maskChar;
	  }).join('');
	}
	
	function insertString(maskOptions, value, insertStr, insertPos) {
	  var mask = maskOptions.mask,
	      maskChar = maskOptions.maskChar,
	      prefix = maskOptions.prefix;
	  var arrayInsertStr = insertStr.split('');
	  var isInputFilled = isFilled(maskOptions, value);
	
	  var isUsablePosition = function isUsablePosition(pos, character) {
	    return !isPermanentChar(maskOptions, pos) || character === mask[pos];
	  };
	
	  var isUsableCharacter = function isUsableCharacter(character, pos) {
	    return !maskChar || !isPermanentChar(maskOptions, pos) || character !== maskChar;
	  };
	
	  if (!maskChar && insertPos > value.length) {
	    value += mask.slice(value.length, insertPos);
	  }
	
	  arrayInsertStr.every(function (insertCharacter) {
	    while (!isUsablePosition(insertPos, insertCharacter)) {
	      if (insertPos >= value.length) {
	        value += mask[insertPos];
	      }
	
	      if (!isUsableCharacter(insertCharacter, insertPos)) {
	        return true;
	      }
	
	      insertPos++; // stop iteration if maximum value length reached
	
	      if (insertPos >= mask.length) {
	        return false;
	      }
	    }
	
	    var isAllowed = isAllowedChar(maskOptions, insertPos, insertCharacter) || insertCharacter === maskChar;
	
	    if (!isAllowed) {
	      return true;
	    }
	
	    if (insertPos < value.length) {
	      if (maskChar || isInputFilled || insertPos < prefix.length) {
	        value = value.slice(0, insertPos) + insertCharacter + value.slice(insertPos + 1);
	      } else {
	        value = value.slice(0, insertPos) + insertCharacter + value.slice(insertPos);
	        value = formatValue(maskOptions, value);
	      }
	    } else if (!maskChar) {
	      value += insertCharacter;
	    }
	
	    insertPos++; // stop iteration if maximum value length reached
	
	    return insertPos < mask.length;
	  });
	  return value;
	}
	
	function getInsertStringLength(maskOptions, value, insertStr, insertPos) {
	  var mask = maskOptions.mask,
	      maskChar = maskOptions.maskChar;
	  var arrayInsertStr = insertStr.split('');
	  var initialInsertPos = insertPos;
	
	  var isUsablePosition = function isUsablePosition(pos, character) {
	    return !isPermanentChar(maskOptions, pos) || character === mask[pos];
	  };
	
	  arrayInsertStr.every(function (insertCharacter) {
	    while (!isUsablePosition(insertPos, insertCharacter)) {
	      insertPos++; // stop iteration if maximum value length reached
	
	      if (insertPos >= mask.length) {
	        return false;
	      }
	    }
	
	    var isAllowed = isAllowedChar(maskOptions, insertPos, insertCharacter) || insertCharacter === maskChar;
	
	    if (isAllowed) {
	      insertPos++;
	    } // stop iteration if maximum value length reached
	
	
	    return insertPos < mask.length;
	  });
	  return insertPos - initialInsertPos;
	}

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(25);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactTypist = __webpack_require__(37);
	
	var _reactTypist2 = _interopRequireDefault(_reactTypist);
	
	var _reactBurgerMenu = __webpack_require__(35);
	
	var _reactInputMask = __webpack_require__(293);
	
	var _reactInputMask2 = _interopRequireDefault(_reactInputMask);
	
	var _reactHelmet = __webpack_require__(36);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _footer = __webpack_require__(27);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _icon = __webpack_require__(28);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _menu = __webpack_require__(41);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _phone = __webpack_require__(43);
	
	var _phone2 = _interopRequireDefault(_phone);
	
	var _tusk = __webpack_require__(44);
	
	var _tusk2 = _interopRequireDefault(_tusk);
	
	var _twitter = __webpack_require__(45);
	
	var _twitter2 = _interopRequireDefault(_twitter);
	
	var _heart = __webpack_require__(38);
	
	var _heart2 = _interopRequireDefault(_heart);
	
	var _like = __webpack_require__(40);
	
	var _like2 = _interopRequireDefault(_like);
	
	var _laugh = __webpack_require__(39);
	
	var _laugh2 = _interopRequireDefault(_laugh);
	
	var _message = __webpack_require__(42);
	
	var _message2 = _interopRequireDefault(_message);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var contact = function (_Component) {
	  _inherits(contact, _Component);
	
	  function contact(props) {
	    _classCallCheck(this, contact);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.toggleMenu = function () {
	      _this.setState({ menuOpen: !_this.state.menuOpen });
	    };
	
	    _this.state = {
	      menuOpen: false,
	      isOpen: false,
	      youtubeId: null
	    };
	    return _this;
	  }
	
	  // This keeps your state in sync with the opening/closing of the menu
	  // via the default means, e.g. clicking the X, pressing the ESC key etc.
	
	
	  contact.prototype.handleStateChange = function handleStateChange(state) {
	    this.setState({ menuOpen: state.isOpen });
	  };
	
	  // This can be used to close the menu, e.g. when a user clicks a menu item
	
	
	  contact.prototype.closeMenu = function closeMenu() {
	    this.setState({ menuOpen: false });
	  };
	
	  // This can be used to toggle the menu, e.g. when using a custom icon
	  // Tip: You probably want to hide either/both default icons if using a custom icon
	  // See https://github.com/negomi/react-burger-menu#custom-icons
	
	
	  contact.prototype.render = function render() {
	    var _this2 = this;
	
	    var Signature = _react2.default.createElement(
	      'svg',
	      { viewBox: '0 0 199 143', xmlns: 'http://www.w3.org/2000/svg' },
	      _react2.default.createElement(
	        'g',
	        { id: 'Page-1', fill: 'none', fillRule: 'evenodd', stroke: '#000' },
	        _react2.default.createElement('path', { d: 'M49.1416016,31.1152344 C75.2822266,8.24153646 94.8652344,-1.73730469 107.890625,1.17871094 C127.428711,5.55273438 107.850586,23.5957031 89.9755859,41.9179687 C72.1005859,60.2402344 48.3701172,84.2607422 61.9423828,84.2607422 C75.5146484,84.2607422 190.460938,39.0410156 174.953125,18.2646484 C159.445313,-2.51171875 97.7431641,14.2675781 89.9755859,20.3095703 C82.2080078,26.3515625 59.3632813,35.0810547 94.2402344,61.4013672 C129.117188,87.7216797 146.483398,106.082031 143.764648,119.708008 C141.045898,133.333984 124.748047,142.709961 102.599609,141.464844 C80.4511719,140.219727 63.8066406,137.329102 63.8066406,119.708008 C63.8066406,102.086914 98.2822266,92.1962891 149.499023,79.2382813 C200.71582,66.2802734 212.223633,59.1152344 177.994141,54.3701172 C143.764648,49.625 68.6064453,41.9443359 27.2304687,45.6464844 C-0.353515625,48.1145833 -6.02669271,50.2369792 10.2109375,52.0136719',
	          id: '1-stroke' }),
	        _react2.default.createElement('path', { d: 'M65.0527344,50.0185547 C65.811849,72.8219401 67.96875,89.7386068 71.5234375,100.768555',
	          id: '2-stroke' })
	      )
	    );
	    return _react2.default.createElement(
	      'div',
	      { id: 'outer-container' },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Contact | TUSK, Inc.'
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: 'We draw on decades of corporate, non-profit, and political victories to empower a new generation of innovators with the hard-won context of yesterday and the tools to shape tomorrow.' })
	      ),
	      _react2.default.createElement(
	        _reactBurgerMenu.slide,
	        {
	          pageWrapId: 'page-wrap',
	          width: '75vw',
	          isOpen: this.state.menuOpen,
	          customBurgerIcon: false,
	          onStateChange: function onStateChange(state) {
	            return _this2.handleStateChange(state);
	          },
	          bodyClassName: 'menu-open'
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'container py-4' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'mt-4 mb-4' },
	            'New norms. New ideas. New TUSK.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Welcome to the new normal: an evolving idea of what it means to be an influencer, a global citizen, a changemaker. \u201CPolitics\u201D are no longer confined to campaigns. The new social order bends and breaks with every\xA0',
	            _react2.default.createElement(
	              'span',
	              { className: 'icon-animation' },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_icon2.default, { icon: _twitter2.default, height: 24 })
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_icon2.default, { icon: _heart2.default, height: 15, fill: '#e95b4b' })
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_icon2.default, { icon: _like2.default, height: 24, fill: '#238af7' })
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_icon2.default, { icon: _laugh2.default, height: 15 })
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_icon2.default, { icon: _message2.default, height: 15 })
	              )
	            ),
	            '\xA0as disruption reigns supreme. From the classroom to the boardroom\u2014and everywhere in between\u2014agility and insurgency run the show. Get ready.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Even in this unprecedented era, success relies on experience. TUSK draws on decades of corporate, non-profit, and political victories to empower a new generation of innovators with the hard-won context of yesterday and the tools to shape tomorrow.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'The rules have changed. So have we. Labels mean nothing in this new landscape: If you\u2019re trying to do something extraordinary, we want to help.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'So. Let\u2019s get started.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ron' },
	            Signature,
	            _react2.default.createElement(
	              'div',
	              { className: 'h6 mb-0 mt-3' },
	              '- Ron Steslow'
	            ),
	            _react2.default.createElement(
	              'i',
	              null,
	              'President, TUSK INC'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-6' },
	              _react2.default.createElement(
	                'a',
	                { role: 'button', tabIndex: 0, className: 'mt-5 btn btn-secondary btn-block', onClick: function onClick() {
	                    return _this2.toggleMenu();
	                  } },
	                'Let\'s Talk'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { id: 'page-wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container-fluid d-md-block d-none' },
	          _react2.default.createElement(
	            'div',
	            { className: 'pt-3 pb-5' },
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary', onClick: function onClick() {
	                  return _this2.toggleMenu();
	                } },
	              _react2.default.createElement(_icon2.default, { icon: _menu2.default, width: 24, height: 30, fill: '#fff' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'container-fluid' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-5 logo-area' },
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-primary d-inline-block d-md-none', onClick: function onClick() {
	                    return _this2.toggleMenu();
	                  } },
	                _react2.default.createElement(_icon2.default, { icon: _menu2.default, width: 24, height: 30, fill: '#fff' })
	              ),
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/', className: 'logo', href: '#' },
	                _react2.default.createElement(_icon2.default, { icon: _tusk2.default, height: 70, fill: '#000' })
	              ),
	              _react2.default.createElement(
	                'h2',
	                { className: 'tagline' },
	                'Footnotes to Frontrunners.'
	              ),
	              _react2.default.createElement(
	                'a',
	                { className: 'd-inline-block d-md-none btn btn-primary', href: 'tel:(202)644-8484' },
	                _react2.default.createElement(_icon2.default, { icon: _phone2.default, width: 24, height: 30, fill: '#fff' })
	              ),
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/', role: 'button', tabIndex: 0, className: 'd-none d-md-inline-block mt-md-4 btn btn-lg btn-secondary' },
	                'Home'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-7 py-3 ml-auto v-center-right' },
	              _react2.default.createElement(
	                _reactTypist2.default,
	                { className: 'h1 mb-5 ml-0 ml-md-4' },
	                'Contact us.'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'px-md-4 pl-0' },
	                'TUSK is not engaging new clients at this time. If there\u2019s an opportunity you\u2019d like us to consider, please feel free to send a note using the contact form. Otherwise, you can find Ron Steslow\u2019s current work at ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://politicology.com' },
	                  'Politicology.com'
	                ),
	                '.'
	              ),
	              _react2.default.createElement(
	                'form',
	                {
	                  name: 'contact',
	                  action: '/contact/success/',
	                  method: 'post',
	                  'data-netlify': 'true',
	                  'data-netlify-honeypot': 'bot-field',
	                  className: 'px-md-4 pl-0'
	                },
	                _react2.default.createElement('input', { type: 'hidden', name: 'form-name', value: 'contact' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-group' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-6 mb-4' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'sr-only', 'for': 'firstName' },
	                        'First Name'
	                      ),
	                      _react2.default.createElement('input', { id: 'firstName', name: 'firstName', type: 'text', className: 'form-control', placeholder: 'First name', required: true })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-6 mb-4' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'sr-only', 'for': 'lasttName' },
	                        'Last Name'
	                      ),
	                      _react2.default.createElement('input', { id: 'lastName', name: 'lastName', type: 'text', className: 'form-control', placeholder: 'Last name', required: true })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col mb-4' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'sr-only', 'for': 'emailAddress' },
	                        'Email Address'
	                      ),
	                      _react2.default.createElement('input', { id: 'emailAddress', name: 'emailAddress', type: 'email', className: 'form-control', placeholder: 'Email Address', required: true })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col mb-4' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'sr-only', 'for': 'phoneNumber' },
	                        'What is the best number to reach you?'
	                      ),
	                      _react2.default.createElement(_reactInputMask2.default, { id: 'phoneNumber', name: 'phoneNumber', type: 'tel', className: 'form-control', mask: '(999) 999-9999', placeholder: 'Phone Number', srequired: true })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col mb-4' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'sr-only', 'for': 'messageText' },
	                        'How can we help?'
	                      ),
	                      _react2.default.createElement('textarea', { id: 'messageText', name: 'messageText', className: 'form-control', rows: '3', placeholder: 'How can we help?', required: true })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'visually-hidden' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'sr-only' },
	                      'Don\u2019t fill this out if you\'re human: ',
	                      _react2.default.createElement('input', { name: 'bot-field' })
	                    )
	                  ),
	                  _react2.default.createElement('div', { 'data-netlify-recaptcha': true })
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { type: 'submit', className: 'btn btn-primary' },
	                  'Submit'
	                )
	              ),
	              _react2.default.createElement(_footer2.default, null)
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return contact;
	}(_react.Component);
	
	exports.default = contact;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-index-js-2b4e3c735be83d9b40a6.js